import { CSSProperties } from "react";
import { createStyledElement } from "../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

const containerStyle: CSSProperties = {
  display: "flex",
  width: "80%",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: 16,
};

const authContainerStyle = (): CSSProperties => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "100vh",
  width: "100%",
  padding: isMobileViewport() ? "16px 8px 24px" : "32px 16px",
  boxSizing: "border-box",
  overflow: "hidden",
  background:
    "radial-gradient(circle at 10% 10%, rgba(22, 119, 255, 0.16), transparent 38%), radial-gradient(circle at 90% 0%, rgba(74, 144, 226, 0.12), transparent 42%), linear-gradient(160deg, #f7faff 0%, #eef4ff 58%, #f9fbff 100%)",
});

const authContainerChildStyle = (): CSSProperties => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  margin: isMobileViewport() ? 0 : "2% 0%",
  width: isMobileViewport() ? "100%" : 600,
  maxWidth: 600,
  padding: isMobileViewport() ? "36px 0 40px 0" : "75px 0px 90px 0px",
  borderRadius: isMobileViewport() ? 16 : 20,
  backgroundColor: "#ffffff",
  boxShadow: "rgb(99 99 99 / 20%) 0px 2px 8px 0px",
  boxSizing: "border-box",
  overflow: "hidden",
});

const formElementStyle: CSSProperties = {
  width: "100%",
  height: 50,
  borderRadius: 10,
  border: "none",
  backgroundColor: "#ebebeb",
  padding: "0 10px",
  transition: "width 0.3s ease-in-out",
  outline: "none",
  fontWeight: "bold",
};

const buttonCustomStyle: CSSProperties = {
  width: "100%",
  color: "white",
  backgroundColor: "rgb(14, 191, 255)",
  border: "1px solid rgb(0, 184, 252)",
  borderRadius: 10,
  height: 50,
  fontWeight: "bold",
};

const languagSwitcherContainerStyle: CSSProperties = {
  alignSelf: "flex-end",
};

export const Container = createStyledElement("form", containerStyle);
export const AuthContainer = createStyledElement("div", authContainerStyle);
export const AuthContainerChild = createStyledElement("div", authContainerChildStyle);
export const FormElement = createStyledElement("input", formElementStyle);
export const FormElementSelect = createStyledElement("select", formElementStyle);
export const ButtonCustom = createStyledElement("button", buttonCustomStyle);
export const LanguagSwitcherContainer = createStyledElement(
  "div",
  languagSwitcherContainerStyle
);
